import { API_ENDPOINTS } from '@/constants/api-endpoints';
import { apiInstance } from '@/utils';
import type { AccountPriority } from '@/types/prospects';

export interface WhyNowReason {
  audienceName: string;
  // #4544 Phase 3: the same "fact operator value" text the delivered Slack/Teams card's "Alert
  // Triggered By" field already shows (mb-server's formatMatchedConditions) -- null when the
  // audience matched via a source that predates matched-conditions capture (e.g. a legacy
  // audience_play row with no per-condition threading), not a client-side error state.
  reason: string | null;
}

export interface LiveVisitor {
  visitorId: string;
  threadId: string | null;
  companyName: string | null;
  companyDomain: string | null;
  fitScore: number | null;
  fitLabel: string | null;
  accountPriorityEnabled?: boolean;
  accountPriority?: AccountPriority | null;
  audienceNames: string[];
  whyNow: WhyNowReason[];
  currentPage: string | null;
  dwellSeconds: number;
  pageViews: number;
  isReturning: boolean;
  industry: string | null;
  employeeRange: string | null;
  location: string | null;
  hasStartedConversation: boolean;
}

export interface LiveVisitorsResponse {
  visitors: LiveVisitor[];
  activeWithinMinutes: number;
}

export const getLiveVisitors = async (): Promise<LiveVisitorsResponse> => {
  const response = await apiInstance.get(API_ENDPOINTS.liveVisitors);
  return response.data;
};

export const pounceLiveVisitor = async (
  visitorId: string,
  message: string,
): Promise<{ threadId: string }> => {
  const response = await apiInstance.post(API_ENDPOINTS.pounceLiveVisitor(visitorId), { message });
  return response.data;
};

export const dismissLiveVisitor = async (visitorId: string): Promise<void> => {
  await apiInstance.post(API_ENDPOINTS.dismissLiveVisitor(visitorId));
};
